import MuiLinearProgress from "@mui/material/LinearProgress";

export default function LinearProgress(props) {
  return <MuiLinearProgress {...props} />;
}
